import { Routes, Route } from 'react-router-dom';
import { PrivateRoute } from './PrivateRoute';

import {
  HomePage,
  ImpersonationPage,
  LoginPage,
  ErrorPage,
  SystemAccessPage,
} from 'app/pages';
import {
  ChangePasswordPage,
  RecoverPasswordPage,
  ResetPasswordPage,
  ConfirmationEmailPage,
} from 'user/pages';
import { HOME_PATH } from '../routes';
import {
  CHANGE_PASSWORD_PATH,
  PASSWORD_EXPIRED_PATH,
  LOGIN_PATH,
  OPERATOR_LOGIN_PATH,
  RECOVER_PASSWORD_PATH,
  FORBIDDEN_PATH,
  RESET_PASSWORD_PATH,
  CONFIRMATION_EMAIL_PATH,
  CREATION_USERS_PATH,
  LIST_USERS_PATH,
  DETAIL_USERS_PATH,
  EDIT_USERS_PATH,
  SERVICE_UNAVAILABLE_PATH,
  SYSTEM_ACCESS_PATH,
  IMPERSONATION_HOME_PATH,
} from 'user/routes';
import {
  ACCOUNT_REFUND_PATH,
  ACCOUNT_DISTRIBUTION_PATH,
  ACCOUNT_TRANSFER_HISTORY_PATH,
} from 'core/cuenta/routes';
import { LIST_CARDS_PATH, CARD_ASSOCIATE_TO_COSTCENTER } from 'core/tarjeta/routes';
import {
  COST_CENTRE_LIST_PATH,
  COST_CENTRE_MASS_DISTRIBUTION_PATH,
  COST_CENTRE_CREATE_PATH,
  COST_CENTRE_EDIT_PATH,
  COST_CENTRE_MOVE_PATH,
} from 'core/centrocosto/routes';
import { CONSULTAR_REPORTE_PATH } from 'core/reporte/routes';
import { CostCentreListPage } from 'core/centrocosto/pages/CostCentreListPage/CostCentreListPage';
import { FundsDistributionProvider } from 'core/cuenta/contexts/FundsDistributionContext';
import { FundsDistributionPage } from 'core/cuenta/pages/FundsDistributionPage/FundsDistributionPage';
import { MassFundsDistributionPage } from 'core/centrocosto/pages/MassFundsDistributionPage/MassFundsDistributionPage';
import { MassFundsDistributionProvider } from 'core/centrocosto/contexts/MassFundsDistributionContext';
import { RefundsProvider } from 'core/cuenta/contexts/RefundsContext';
import { RefundsPage } from 'core/cuenta/pages/RefundsPage/RefundsPage';
import { TransfersProvider } from 'core/cuenta/contexts/TransfersContext';
import { TransfersPage } from 'core/cuenta/pages/TransfersPage/TransfersPage';
import { CuentaSelectorProvider } from 'core/cuenta/contexts/CuentaSelectorContext';
import { UsersListPage } from 'user/pages/UsersList/UsersListPage';
import { UserDetailPage } from 'user/pages/UserDetail/UserDetailPage';
import { CostCentreCreatePage } from 'core/centrocosto/pages/CostCentreCreatePage/CostCentreCreatePage';
import { UserInfoProvider } from 'user/context/UserInfoContext';
import { CostCentreEditPage } from 'core/centrocosto/pages/CostCentreEditPage/CostCentreEditPage';
import { CardsListPage } from 'core/tarjeta/pages/CardsListPage/CardsListPage';
import { ConsultarReportePage } from 'core/reporte/pages/ConsultarReportePage/ConsultarReportePage';
import { PasswordExpiredInfoPage } from '../../user/pages/PasswordExpiredInfoPage/PasswordExpiredInfoPage';
import { AssociateCardToCostCenterPage } from '../../core/tarjeta/pages/AssociateCardToCostCenterPage/AssociateCardToCostCenterPage';
import {
  TRANSACTIONS_SUMMARY_PATH,
  TRANSACTIONS_HISTORY_PATH,
} from 'core/movimientos/routes';
import { UserFormPage } from 'user/pages/UserFormPage/UserFormPage';
import { CardListProvider } from 'core/tarjeta/contexts/CardListContext';
import { CostCentresListProvider } from 'core/centrocosto/contexts/CostCentreListContext';
import { CostCentreMovePage } from 'core/centrocosto/pages/CostCentreMovePage/CostCentreMovePage';
import { TransactionListProvider } from 'core/movimientos/contexts/TransactionListContext';
import { TransactionListPage } from 'core/movimientos/pages/TransactionListPage/TransactionListPage';
import { TransactionSummaryPage } from 'core/movimientos/pages/TransactionSummaryPage/TransactionSummaryPage';
import { TransactionSummaryProvider } from 'core/movimientos/contexts/TransactionSummaryContext';
import { UserListProvider } from 'user/context/UserListContext';

export function AppRouter() {
  return (
    <Routes>
      <Route path={LOGIN_PATH} element={<LoginPage />}></Route>
      <Route path={OPERATOR_LOGIN_PATH} element={<LoginPage />}></Route>

      {/* Rutas privadas */}
      <Route element={<PrivateRoute />}>
        <Route path={HOME_PATH} element={<HomePage />}></Route>
        <Route path={IMPERSONATION_HOME_PATH} element={<ImpersonationPage />}></Route>
        <Route path={CONSULTAR_REPORTE_PATH} element={<ConsultarReportePage />}></Route>
        <Route
          path={LIST_USERS_PATH}
          element={
            <UserListProvider>
              <UsersListPage />
            </UserListProvider>
          }
        ></Route>

        <Route
          path={CREATION_USERS_PATH}
          element={
            <UserInfoProvider>
              <UserFormPage />
            </UserInfoProvider>
          }
        />
        <Route
          path={LIST_CARDS_PATH}
          element={
            <CardListProvider>
              <CardsListPage />
            </CardListProvider>
          }
        ></Route>
        <Route
          path={CARD_ASSOCIATE_TO_COSTCENTER}
          element={<AssociateCardToCostCenterPage />}
        ></Route>
        <Route
          path={DETAIL_USERS_PATH}
          element={
            <UserInfoProvider>
              <UserDetailPage />
            </UserInfoProvider>
          }
        ></Route>
        <Route
          path={EDIT_USERS_PATH}
          element={
            <UserInfoProvider>
              <UserFormPage />
            </UserInfoProvider>
          }
        ></Route>

        <Route
          path={COST_CENTRE_LIST_PATH}
          element={
            <CostCentresListProvider>
              <CostCentreListPage />
            </CostCentresListProvider>
          }
        ></Route>
        <Route path={COST_CENTRE_CREATE_PATH} element={<CostCentreCreatePage />}></Route>
        <Route path={COST_CENTRE_EDIT_PATH} element={<CostCentreEditPage />}></Route>
        <Route path={COST_CENTRE_MOVE_PATH} element={<CostCentreMovePage />}></Route>
        <Route
          path={COST_CENTRE_MASS_DISTRIBUTION_PATH}
          element={
            <MassFundsDistributionProvider>
              <MassFundsDistributionPage />
            </MassFundsDistributionProvider>
          }
        ></Route>
        <Route
          path={ACCOUNT_REFUND_PATH}
          element={
            <RefundsProvider>
              <RefundsPage />
            </RefundsProvider>
          }
        ></Route>
        <Route
          path={ACCOUNT_TRANSFER_HISTORY_PATH}
          element={
            <TransfersProvider>
              <CuentaSelectorProvider>
                <TransfersPage />
              </CuentaSelectorProvider>
            </TransfersProvider>
          }
        ></Route>
        <Route
          path={ACCOUNT_DISTRIBUTION_PATH}
          element={
            <FundsDistributionProvider>
              <FundsDistributionPage />
            </FundsDistributionProvider>
          }
        ></Route>
        <Route
          path={TRANSACTIONS_HISTORY_PATH}
          element={
            <TransactionListProvider>
              <TransactionListPage />
            </TransactionListProvider>
          }
        ></Route>
        <Route
          path={TRANSACTIONS_SUMMARY_PATH}
          element={
            <TransactionSummaryProvider>
              <TransactionSummaryPage />
            </TransactionSummaryProvider>
          }
        ></Route>
      </Route>

      <Route path={PASSWORD_EXPIRED_PATH} element={<PasswordExpiredInfoPage />} />
      <Route path={CONFIRMATION_EMAIL_PATH} element={<ConfirmationEmailPage />}></Route>
      <Route path={CHANGE_PASSWORD_PATH} element={<ChangePasswordPage />}></Route>
      <Route path={SYSTEM_ACCESS_PATH} element={<SystemAccessPage />}></Route>
      <Route path={RECOVER_PASSWORD_PATH} element={<RecoverPasswordPage />}></Route>
      <Route path={RESET_PASSWORD_PATH} element={<ResetPasswordPage />}></Route>
      <Route path={FORBIDDEN_PATH} element={<ErrorPage error="forbidden" />} />
      <Route
        path={SERVICE_UNAVAILABLE_PATH}
        element={<ErrorPage error="service_unavailable" />}
      />
      <Route path="*" element={<ErrorPage error="not_fonud" />} />
    </Routes>
  );
}
